import { Component, output } from '@angular/core';

@Component({
  selector: 'bottomsheet-layout',
  standalone: true,
  templateUrl: './bottomsheet-layout.component.html',
})
export class BottomsheetLayoutComponent {
  dismiss = output<void>();

  close(): void {
    this.dismiss.emit();
  }
}
